import type { ColorName } from '@sohanscript/styles/types';

export const isSSR = typeof window === 'undefined';

export const svgToBase64 = (str: string) =>
	isSSR ? Buffer.from(str).toString('base64') : window.btoa(str);

export const shimmer = (w: number | `${number}`, h: number | `${number}`) => {
	const color = { r: 200, g: 200, b: 200, a: 0.15 };
	return `
<svg width="${w}" height="${h}" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="g">
      <stop stop-color="rgba(${color.r},${color.g},${color.b},0)" offset="0%"/>
      <stop stop-color="rgba(${color.r},${color.g},${color.b},${color.a})" offset="50%"/>
      <stop stop-color="rgba(${color.r},${color.g},${color.b},0)" offset="100%"/>
    </linearGradient>
  </defs>
  <rect width="${w}" height="${h}" fill="rgba(${color.r},${color.g},${color.b},0.05)"/>
  <rect id="r" width="${w}" height="${h}" fill="url(#g)"/>
  <animate xlink:href="#r" attributeName="x" from="-${w}" to="${w}" dur="1.5s" repeatCount="indefinite"/>
</svg>`;
};

export function convertToNormalCase(inputString: string) {
	const splittedString = inputString.split('.').pop();
	const string = splittedString || inputString;
	const words = string.replace(/([a-z])([A-Z])/g, '$1 $2').split(/_|\s+/);
	const capitalizedWords = words.map(
		(word) => word.charAt(0).toUpperCase() + word.slice(1),
	);
	return capitalizedWords.join(' ');
}

export function splitStringWithComma(string: string): string[] {
	const separator = ',';
	const splitString = string.split(separator);
	return splitString.map((substring) => substring.trim());
}

export function splitArrayIntoThree(array: unknown[]) {
	const chunkSize = Math.ceil(array.length / 3);
	const chunks: unknown[][] = [];
	for (let i = 0; i < array.length; i += chunkSize) {
		chunks.push(array.slice(i, i + chunkSize));
	}
	return chunks;
}

export function findScrollableParent(
	element: HTMLElement | null,
): HTMLElement | null {
	if (!element) return null;

	let parent = element.parentElement;
	while (parent) {
		const style = window.getComputedStyle(parent);
		const overflowY = style.overflowY;
		const overflow = style.overflow;

		if (
			overflowY === 'auto' ||
			overflowY === 'scroll' ||
			overflow === 'auto' ||
			overflow === 'scroll'
		) {
			return parent;
		}
		parent = parent.parentElement;
	}

	return null;
}

export function scrollIntoContainerView(
	element: HTMLElement,
	container: HTMLElement,
	behavior: ScrollBehavior = 'smooth',
) {
	const elementRect = element.getBoundingClientRect();
	const containerRect = container.getBoundingClientRect();

	const elementTop = elementRect.top - containerRect.top + container.scrollTop;
	const elementBottom = elementTop + elementRect.height;

	const containerTop = container.scrollTop;
	const containerBottom = containerTop + containerRect.height;

	if (elementTop < containerTop) {
		container.scrollTo({
			top: elementTop - 10,
			behavior,
		});
	} else if (elementBottom > containerBottom) {
		container.scrollTo({
			top: elementBottom - containerRect.height + 10,
			behavior,
		});
	}
}

export function getColor(v: ColorName) {
	if (typeof window === 'undefined') return '';
	const style = getComputedStyle(document.documentElement);
	return style.getPropertyValue(`--${v}`).trim();
}
